import React from 'react'
import { Box, Link } from '@ally/metronome-ui'

import { StyledBadgeIcon, StyledBadgeHeading } from './StyledComponents'
import { isAllyPreferred, parseUserAgent } from '../utils/preferredBrowser'

import PreferredBrowserOnIcon from '../../../../static-assets/images/badges/preferred/preferred-browser-on.svg'
import PreferredBrowserOffIcon from '../../../../static-assets/images/badges/preferred/preferred-browser-off.svg'

const Icon: React.FC<{ type: string }> = ({ type }) => {
  const IconLookup = {
    SUCCESS: (
      <PreferredBrowserOnIcon
        data-testid="preferred-browser-success-badge"
        title="Illustration: Light purple hexagonal badge with a dark purple globe-like icon with gridlines and green dots to represent internet/browser security. A white checkmark on a green circle sits on the bottom left of the badge indicating you’re using an Ally-preferred browser."
      />
    ),
    FAILURE: (
      <PreferredBrowserOffIcon
        data-testid="preferred-browser-failure-badge"
        title="Illustration: Light purple hexagonal badge with a dark purple globe-like icon with gridlines and red dots to represent internet/browser security. A white exclamation point on a red circle sits on the bottom left of the badge indicating you need to update your browser."
      />
    ),
  }
  return (
    <StyledBadgeIcon>
      {IconLookup[type as keyof typeof IconLookup]}
    </StyledBadgeIcon>
  )
}

const Heading: React.FC<{ type: string }> = ({ type }) => {
  if (type === 'SUCCESS') {
    return <StyledBadgeHeading>Lookin&apos; Good!</StyledBadgeHeading>
  }

  return <StyledBadgeHeading>Level Up</StyledBadgeHeading>
}

const Text: React.FC<{ type: string }> = ({ type }) => {
  if (type === 'SUCCESS') {
    return <p>You&apos;re using an Ally-preferred browser.</p>
  }

  return (
    <p>
      <Link
        to="https://www.ally.com/go/learn/browser-support/"
        text="Update your browser"
        target="_blank"
        withAllyTM="levelUp-updateYourBrowser"
      />{' '}
      for a security boost.
    </p>
  )
}

const PreferredBrowserBadge: React.FC = () => {
  const { browser, browserVersion } = parseUserAgent(window.navigator.userAgent)

  const badgeType = isAllyPreferred(browser ?? '', browserVersion)
    ? 'SUCCESS'
    : 'FAILURE'

  return (
    <Box marginTop="xs" display="flex" flexDirection="row">
      <Icon type={badgeType} />
      <Box marginRight="sm" marginTop="4px" width="100%">
        <Heading type={badgeType} />
        <Text type={badgeType} />
      </Box>
    </Box>
  )
}

export { PreferredBrowserBadge }
